import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'gl-radio-button-units',
    templateUrl: './radio-button-units.component.html',
    styleUrls: ['./radio-button-units.component.scss'],
    standalone: false
})
export class RadioButtonUnitsComponent {
  @HostBinding('class.checked') @Input() public checked: boolean;
}
